"use client";
import { jsxs as a, jsx as s } from "react/jsx-runtime";
import { useId as R } from "react";
import U from "clsx";
import { fieldVariants as w } from "./Field.variants.js";
import { FieldHelperText as W } from "./HelperText/FieldHelperText.js";
import { FieldErrorText as X } from "./ErrorText/FieldErrorText.js";
const j = w.definition().defaultVariants, t = w, I = ({
  autoFocus: H,
  children: $,
  className: q,
  defaultValue: v,
  disableAnimation: c = !1,
  errorText: d,
  helperText: p,
  iconEnd: m,
  iconStart: f,
  id: B,
  isDisabled: o = !1,
  isInvalid: r = !1,
  isReadOnly: O = !1,
  isRequired: g = !1,
  labelText: i,
  name: k,
  placeholder: C,
  size: e = j.size,
  slotEnd: h,
  slotStart: x,
  type: y = j.type,
  value: G
}) => {
  const N = R(), u = B ?? `${N}-control`, l = `${N}-supportText`, n = r && !!d, S = !n && !!p, J = n || S ? l : void 0, K = t.root({
    isDisabled: o,
    isInvalid: r,
    type: y,
    size: e,
    className: q
  }), L = t.container({
    isDisabled: o,
    isInvalid: r,
    size: e
  }), M = t.content({
    disableAnimation: c,
    isDisabled: o,
    size: e
  }), P = t.control({
    isDisabled: o,
    isInvalid: r,
    size: e
  }), Q = t.label({
    disableAnimation: c,
    isDisabled: o,
    isInvalid: r,
    size: e
  }), T = t.icon({ disableAnimation: c, isDisabled: o, isInvalid: r }), F = t.slot(), V = t.supportText();
  return /* @__PURE__ */ a("div", { className: K, children: [
    /* @__PURE__ */ a(
      "label",
      {
        className: L,
        htmlFor: u,
        children: [
          x && /* @__PURE__ */ s("span", { className: F, children: x }),
          /* @__PURE__ */ a("span", { className: M, children: [
            $({
              "aria-label": e === "xs" ? i : void 0,
              "aria-describedby": J,
              "aria-invalid": r || void 0,
              "aria-required": g || void 0,
              autoFocus: H,
              className: P,
              defaultValue: v,
              disabled: o,
              id: u,
              name: k,
              // For non-select controls, the `placeholder` attribute is necessary
              // to apply styles based on `:placeholder-shown` pseudo-class.
              // If no `placeholder` is provided, we have to keep a space character,
              // as Safari treats an empty placeholder as if none exists.
              placeholder: y === "select" ? void 0 : C || " ",
              readOnly: O,
              value: G
            }),
            e !== "xs" && /* @__PURE__ */ s("span", { className: Q, children: i })
          ] }),
          h && /* @__PURE__ */ s("span", { className: F, children: h }),
          f && /* @__PURE__ */ s(
            "span",
            {
              className: U(
                T,
                "order-first"
                // Visually places this as the first element in a flex container
              ),
              children: f
            }
          ),
          m && /* @__PURE__ */ s("span", { className: T, children: m })
        ]
      }
    ),
    S && /* @__PURE__ */ s(
      W,
      {
        className: V,
        id: l,
        isDisabled: o,
        children: p
      }
    ),
    n && /* @__PURE__ */ s(X, { className: V, id: l, children: d })
  ] });
};
export {
  I as Field
};
